<template>
    <NuxtLayout
        :name="showResult ? 'game-coat-roulette' : 'game-coat'"
    >
        <template #bgImg>
            <img :src="bgImage" />
        </template>
        <!-- ↓ 当前组件在游戏历史窗口内部使用时不需要这个 panel-left，不需要特别干预它也不会显示，因为 game-coat-roulette 内部不接受这个 slot  -->
        <!-- ↓ 下方的 v-if 暂时停用了， 2025.02.04 16:07:02 星期二（为了消除 hydration 错误示警） -->
        <template
            v-slot:panel-left
            vvif="!showResult"
        >
            <div class="chips-bar">
                <div  class="default-controls__chip-info">
                    <small  class="default-controls__chip-label">
                        {{ $t('roulette.ChipValue') }}
                    </small>
                    <div  class="default-controls__chip-sum">
                        <CurrentCoin class="currency__icon" size="16px"/>
                        <ClientOnly>
                            {{ oCoinInUse?.amountStr }}
                        </ClientOnly>
                    </div>
                </div>
                <!-- ↑ 金额信息  -->
                <!-- ↓ 筹码列表  -->
                <ul class="splide__list"
                    id="splide02-list"
                    role="presentation"
                    :style="{
                        'padding-right': aCoinArr.at(-1).inUse ? `8px` : `0`,
                    }"
                >
                    <li class="splide__slide default-controls__chip-item"
                        role="group"
                        aria-roledescription="slide"
                        aria-label="1 of 7"
                        v-for="(cur, idx) of aCoinArr"
                        :key="idx"
                        @click="setChipInUse(idx)"
                        :class="{
                            'default-controls__chip-item--active': cur.inUse,
                            'default-controls__chip-item--disabled': !!cur.sTip,
                        }"
                    >
                        <ClientOnly>
                            <Popper
                                hover
                                arrow
                                placement="top"
                                :style="popperStyle"
                            >
                                <span class="one-coin" >
                                    <img class="default-controls__chip-img"
                                        :src="cur.img"
                                    />
                                    <span class="default-controls__chip-value">
                                        {{ cur.name }}
                                    </span>
                                </span>
                                <template #content v-if="!!cur.sTip">
                                    <p style="min-width: 150px; max-width: 200px">
                                        {{ cur.sTip }}
                                    </p>
                                </template>
                            </Popper>
                        </ClientOnly>
                    </li>
                </ul>
            </div>
            <CasinoBetOptionSection
                class=""
                :betTookit="void 0"
                :auto-bet-tool-kit="void 0"
                v-model:bet-amount-modal-value="oForm.amount"
                v-model:is-submiting="isDisabled"
                :sound="void 0"
                :isAuto="isAutoMode"
                :is-fast="isFast"
                @change-mode="toChangeMode"
                :changeAmount="changeAmount"
            >
                <!-- ↓下注按钮 -->
                <template #bet-button>
                    <ButtonThe2RowsButton
                        narrow
                        size="lg"
                        class="h-full"
                        full-width
                        @click="butButtonClick01()"
                        :disabled="betButtonDisabled"
                        :dismark="!!betButtonDisabled"
                        v-click-and-rest
                    >
                        {{ 
                            (()=>{
                                if (isAutoMode) {
                                    if (oForm.isSubmiting) {
                                        return $t(globalStore.autoModeBtnWords.stop);
                                    }
                                    return $t(globalStore.autoModeBtnWords.start);
                                }
                                return $t('game.bet');
                            })()
                        }}
                        <template #secondRow v-if="isAutoMode">
                            <span class="inline-block mt-1">
                                {{ autoOption.sRoundsRest }}
                            </span>
                        </template>
                    </ButtonThe2RowsButton>
                </template>
                <!-- 点击触发预警target -->
                <template #button-mask v-if="oForm.amount <= 0">
                    <div class="button-mask" @click="handleClickMask"></div>
                </template>
            </CasinoBetOptionSection>
        </template>
        <!--
            左
            右
            大
            分
            界
        -->
        <!-- ↓ 下方的 specialMark 临时关闭了（否则 hydration 出错），进入观察期 2025.02.04 15:25:12 星期二  -->
        <template
            v-slot:playing-area-right
            vvif="specialMark"
        >
            <div class="game-layout__game-inner" 
                :class="{'result-mode': showResult}"
            >
                <div class="game-wrapper">
                    <!-- ↓需要缩放 -->
                    <div class="game-wrapper__wrap"
                        :style="{
                            'transform': showResult ? 'scale(1)' : stageTransform,
                        }"
                    >
                        <div class="game-wrapper__board">
                            <div class="board board--no-animation"
                                :class="{
                                    'mobile-spinning': mobileMode && showMobileResult,
                                    'arrow-box': showWarning
                                }"
                                :style="showResult ? {'background-image': `url(${bg02Image})`} : {}"
                            >
                                <!-- ↓右侧历史 --> 
                                <aside class="board__stats" 
                                    v-if="!showResult"
                                >
                                    <button class="board__btn board__stats-btn"
                                        @click="showHistoryPanel = true"
                                    >
                                        <IconSvgUse use="icon-stats" width="30" height="30"/> 
                                        <q-tooltip class="triangle"
                                            anchor="top middle" self="bottom middle"
                                        >
                                            {{ $t('roulette.History') }}
                                        </q-tooltip>
                                    </button>
                                    <!--  -->
                                    <div class="board__stats-grid"
                                        v-if="showHistoryPanel"
                                    >
                                        <IconSvgUse
                                            use="icon-close"
                                            size="24px"
                                            :style="{'color': '#56557E'}"
                                            @click="showHistoryPanel = false"
                                        />
                                        <div class="board__stats-grid-head">
                                            <h3>
                                                {{ $t('roulette.RouletteHistory') }}
                                            </h3>
                                        </div>
                                        <div class="board__stats-grid-body">
                                            <ClientOnly>
                                                <div class="board__stats-grid-body-part"
                                                    v-for="(oHistory, idx) of aGameResult"
                                                    :key="idx"
                                                    :class="{
                                                        [`board__stats-grid-body-part-${oHistory.color_}`]: true,
                                                    }"
                                                >
                                                    {{ oHistory.rollNumber_ }}
                                                </div>
                                            </ClientOnly>
                                        </div>
                                    </div>
                                    <!-- ↓ 右侧纵向历史信息（移动端时在顶部） -->
                                    <div class="board__stats-cells"
                                        name='a309dkgtg8u69okvn'
                                    >
                                        <ClientOnly>
                                            <TransitionGroup name="historylist">
                                                <span v-for="(oHistory, idx) of aGameResult"
                                                    :key="oHistory.hash"
                                                    class="board__stats-cells-cell"
                                                    :class="{
                                                        [`board__stats-cells-cell-${oHistory.color_}`]: true,
                                                    }"
                                                >
                                                    {{ oHistory.rollNumber_ ?? '' }}
                                                </span>
                                            </TransitionGroup>
                                        </ClientOnly>
                                    </div>
                                </aside>
                                <!--
                                    ↓左侧菜单
                                -->
                                <aside class="specialWrapper"
                                    v-if="!showResult"
                                    @mouseleave="mouseLeaveOption"
                                    @click="showSideMenu = !showSideMenu"
                                    :class="{'pointer-events-none': isRolling}"
                                >
                                    <div class="board__sections-bets"
                                        @click="() => null"
                                    >
                                        <div class="board__sections-label">
                                            <img class="board__sections-image"
                                                src="./img/sections_bets.webp"
                                            />
                                            <p class="board__sections-title">
                                                {{ $t('roulette.SectionBets') }}
                                            </p>
                                        </div>
                                    </div>
                                    <ul class="specialMenu" 
                                        :class="{showing: showSideMenu}"
                                    >
                                        <li v-for="(cur, idx) of aLeftBtn" :key="idx"
                                            @mouseenter="optionAnimation(cur)"
                                            @click="clickOnSpecialOpt(cur)"
                                        >
                                            {{ $t(cur.i18nKey) }}
                                        </li>
                                    </ul>
                                </aside>
                                <!--
                                    ↓ 中间的大转盘
                                -->
                                <ClientOnly>
                                    <Transition v-if="!showResult" >
                                        <div class="board__wheel-wrapper"
                                            v-show="mobileMode ? showMobileResult : true"
                                            :class="{
                                                'disabled-animation': globalStore.client ? !animation : true,
                                            }"
                                        >
                                            <div class="board__wheel-wrapper-rotate">
                                                <img class="board__wheel-image" src="./img/wheel.png" />
                                                <!-- ↓ 提示用户当前选择范围的图形 -->
                                                <svg fill="none" width="285" height="285"
                                                    viewBox="0 0 285 285"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g>
                                                        <g>
                                                            <path fill="rgba(204,159,0,0.7)"
                                                                v-for="(oCurPath, idx) of aPath"
                                                                :key="idx"
                                                                :number="oCurPath.no"
                                                                :opacity="aHovering.includes(oCurPath.no) ? 1: 0"
                                                                :d="oCurPath.dValue"
                                                            ></path>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <!-- ↓ 绘制小球的画布 -->
                                                <canvas
                                                    class="canvas-transition"
                                                    ref="canvas"
                                                    width="570"
                                                    height="570"
                                                    :style="{
                                                        'transform': `rotate(${-angle}deg)`,
                                                        'transition-property': isFast ? 'none !important' : 'all',
                                                    }"
                                                > </canvas>
                                                <img class="board__wheel-wrapper-foreground"
                                                    src="./img/foreground.png"
                                                />
                                                <img class="board__wheel-wrapper-xmid"
                                                    src="./img/xmid.png"
                                                    v-show="!oGameResult.bVisible"
                                                />
                                            </div>
                                            <!-- ↓开奖结果 -->
                                            <Transition >
                                                <div class="win-sector"
                                                    v-show="oGameResult.bVisible"
                                                >
                                                    <img v-if="oGameResult.roll_number == 0" 
                                                        src="./img/green-sector.png"
                                                    />
                                                    <img v-else-if="aRedNumber.includes(oGameResult.roll_number)"
                                                        src="./img/red-sector.png"
                                                    />
                                                    <img v-else src="./img/blue-sector.png" />
                                                    <div  class="sector-data">
                                                        <h2>
                                                            {{oGameResult.roll_number}}
                                                        </h2>
                                                        <p style="margin-top: -8px;"
                                                            v-if="oGameResult.multi > 0"
                                                        >
                                                            x{{oGameResult.multi.beFixed(2)}} 
                                                        </p>
                                                    </div>
                                                </div>
                                            </Transition>
                                        </div>
                                    </Transition>
                                    <!-- ↑ 大转盘 -->
                                    <!--  -->
                                    <!-- ↓ 下方的大片按钮 💎 -->
                                    <Transition>
                                        <!-- v-if 说明：不在游戏历史窗口内 || 在窗口内，但金额已经计算完毕 -->
                                        <!-- v-if="!showResult || oForm.amount > 0" -->
                                        <!-- ↑ 改版之前的说明，新版中永不隐藏 -->
                                        <section
                                            class="board__bets"
                                            :class="{
                                                'no-event': isRolling,
                                            }"
                                            @mouseleave="mouseLeaveOption"
                                            vv-show="mobileMode ? !showMobileResult : true"
                                            :style="{
                                                transform: sRotate || betsBtnTransform,
                                            }"
                                        >
                                            <!-- ↓ 特定下注选项（移动端可见） -->
                                            <div class="board__bets__mobile">
                                                <div class="board__bets__mobile__item"
                                                    v-for="(cur, idx) of aLeftBtn"
                                                    :key="idx"
                                                    :style="{'grid-area': cur.gridArea}"
                                                    @click="clickOnSpecialOpt(cur)"
                                                >
                                                    <template v-if="currentLanguage === 'cn'" >
                                                        <span class="chinese"
                                                            v-for="thisChar of $t(cur.i18nKey).split('')"
                                                        >
                                                            {{ thisChar }}
                                                        </span>
                                                    </template>
                                                    <span v-else>
                                                        {{$t(cur.i18nKey)}}
                                                    </span>
                                                </div>
                                            </div>
                                            <!-- ↓ 撤销，清空按钮 -->
                                            <section
                                                class="board__actions"
                                                v-if="!showResult"
                                            >
                                                <button class="board__btn board__btn-undo"
                                                    @click="goBackward"
                                                    :disabled="isRolling"
                                                >
                                                    <IconSvgUse use="icon-undo" size="24px"/>
                                                    <q-tooltip class="triangle"
                                                        anchor="top middle"
                                                        self="bottom middle"
                                                        v-if="!isRolling"
                                                    >
                                                        {{ $t('roulette.Undo') }}
                                                    </q-tooltip>
                                                </button>
                                                <button class="board__btn board__btn-reset"
                                                    @click="clearAllOption"
                                                    :disabled="isRolling"
                                                >
                                                    <IconSvgUse use="icon-reset" size="24px"/>
                                                    <q-tooltip class="triangle"
                                                        anchor="top middle"
                                                        self="bottom middle"
                                                        v-if="!isRolling"
                                                    >
                                                        {{ $t('roulette.Clear') }}
                                                    </q-tooltip>
                                                </button>
                                            </section>
                                            <!--
                                                分界 
                                                ↓ 大面积下注按钮 
                                            -->
                                            <button
                                                v-for="(cur, idx) of aOptionList"
                                                :key="idx"
                                                :class="{ 
                                                    ...getBtnActiveClassName(cur), 
                                                    [cur.class]: true, 
                                                    [`board__bets__item--${cur.color}`]: true, 
                                                }"
                                                :style="{
                                                    'grid-area': cur.gridArea,
                                                }"
                                                :a-mark="cur.mark"
                                                @mouseenter="optionAnimation(cur)"
                                                @click="clickOnOption(cur)"
                                                @dragover="allowDrop($event, cur)"
                                                @drop="drop($event, cur)"
                                            >
                                                <!-- ↓ 圆形筹码，即已经下注的数量 -->
                                                <!-- ↓ 这样的话将导致移动端点击事件无效：@touchstart.prevent=xx -->
                                                <!-- @contextmenu 在正式版需要判断设备后再执行方法 -->
                                                <div
                                                    class="roulette-chip"
                                                    v-if="cur.placed"
                                                    draggable="true"
                                                    @dragstart="drag($event, idx)"
                                                    @touchstart="onTouchStart($event, cur)"
                                                    @touchend="onTouchEnd($event)"
                                                    @contextmenu.prevent="() => void 0"
                                                >
                                                    <img class="roulette-chip__image"
                                                        :src="getCoinImg(cur)" 
                                                    />
                                                    <small class="roulette-chip__value">
                                                        {{ cur.placed }}
                                                    </small>
                                                </div>
                                                <!-- ↑ 单选，圆形筹码 -->
                                                <!-- ↓ 多选，片区名称-->
                                                <span v-if="cur.title || (cur.value >= 0)"
                                                    class="board__bet-value"
                                                    :class="cur.classOnChild"
                                                >
                                                    {{
                                                        ['even', 'odd', 'Black', 'Red'].includes(cur.title)
                                                        ? $t(`roulette.${cur.title}`)
                                                        : (cur.title || cur.value)
                                                    }}
                                                </span>
                                            </button>
                                        </section>
                                    </Transition>
                                    <!-- ↑ 大面积下注按钮 -->
                                </ClientOnly>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </NuxtLayout>
    <!-- ↓ 自动下注的输入面板（弹窗） -->
    <CasinoAutoSection
        v-if="!showResult"
        :is-fast="isFast"
        :is-submiting="oForm.isSubmiting"
        v-model:amount="oForm.amount"
        :ref="el => oAutoDialog=el"
        :gameName="'rouletteGame'" 
    />
</template>

<script lang="ts">
import soundWind from '@/assets/mp3/roulette/win.mp3';
import soundLose from '@/assets/mp3/roulette/lose.mp3';
import soundClear from '@/assets/mp3/roulette/clear.mp3';
import soundUndo from '@/assets/mp3/roulette/undo.mp3';
import soundChipsSet from '@/assets/mp3/roulette/chips_set.mp3';
import soundSortMusicLoop from '@/assets/mp3/roulette/short_music_loop.mp3';
import soundRolling2Short from '@/assets/mp3/roulette/rolling_2_short.mp3';
import soundRolling2 from '@/assets/mp3/roulette/rolling_2.mp3';
import bg01Image from './img/roulette-bg.webp';
import bg02Image from './img/board-bg.webp';
// ------ ↑ 音乐和图像 -------------------------------------------------------------
import useSettingsStore from '@/stores/settings/index';
import useGlobalStore from '@/stores/global';
import {useJoinStateStore} from '@/stores/cansino/joinState';
import {useUserStore} from '@/stores/user';
import { useGameHistoryStore } from '~/stores/cansino/gameHistory';
import { useRatesStore } from '@/stores/cansino/rates';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
// ------ ↑ stores ------------------------------
import type { FormObject } from '@/common/js/bettingToolkit/index';
import {oMethods} from './js/rouletteGame.js';
import oScssVar from '@/common/style/game.module.scss';
import {useAutoBetToolKit} from '@/common/js/bettingToolkit/auto';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import Popper from "vue3-popper";

import { // 游戏用到的常量 
    aOptionList,
    aCoinList,
    aPath,
    aLeftBtn,
    aRedNumber,
} from './js/rouletteData';

interface BetLimit {
    min: number;
    max: number;
}
const sTranslateY = '-9%';

export default defineComponent({
    name: 'roulette',
    components:{
        Popper,
    },
    props: {
        type: {
            type: String, // 值为 result, 说明用于显示游戏结果  
            default: '',
        },
        historyData: {
            type: Object as PropType<BetHistoryType>, 
            default: () => [], 
        },
    },
    data(){
        const oForm = ref<FormObject>({
            amount: 0,
            isSubmiting: false, // 状态为 false 则停止自动下注
        });
        // ↓ 下注筹码按数值降序 
        const aCoinReverse = deepCopy(aCoinList);
        aCoinReverse.sort((aa, bb) => {
            return bb.value - aa.value;
        });
        // 音乐列表
        const oMusicLib = {
            wind: { src: soundWind, },
            lose: { src: soundLose, },
            clear: { src: soundClear, },
            undo: { src: soundUndo, },
            chipsSet: { src: soundChipsSet, },
            rolling2Short: { src: soundRolling2Short, },
            rolling2: { src: soundRolling2, },
            sortMusicLoop: {
                src: soundSortMusicLoop,
                loop: true,
                isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
            },
        };
        if (this.type == 'result'){
            oMusicLib.sortMusicLoop.loop = false;
            oMusicLib.sortMusicLoop.isBGM = false;
        }
        const popperStyle = {
            '--popper-theme-background-color': '#202A39', 
            '--popper-theme-background-color-hover': '#202A39', 
            '--popper-theme-border-radius': '8px',
            '--popper-theme-padding': '8px 12px',
            '--popper-theme-box-shadow': '3px 6px 9px rgba(0, 0, 0, 0.35)',
        };
        // ↓ 控制界面形态
        const oForInterface = {
            bgImage: bg02Image, // 背景图
            bg01Image,
            bg02Image,
            showSideMenu: false, // 显示左侧特殊下注选项
            showHistoryPanel: false, // 显示历史记录
            aCoinList: deepCopy(aCoinList), // 下注筹码列表
            aCoinReverse,
            aPath: deepCopy(aPath), 
            aHovering: [], // 因“鼠标经过”而点亮的区域
            aShaking: [], // 因“无余额下注”而抖动的区域
            aOptionList: deepCopy(aOptionList), // 重要内容
            aOptionListInitial4AutoMode: [], // 自动下注启动时用于记录初始值
            aHistory: [], // 用户的操作历史记录
            isRolling: false, // 小球旋转进行中 
            iWithB: Number.parseInt(oScssVar.myWidthB), // $with-B
            stageTransform: 'translateX(0) scale(1)',
            betsBtnTransform: '',
            timerOfHidingMobileResult: null,
            currentLanguage: '', // 客户端赋值 
            popperStyle,
        };
        const oBorrowed = {
            oBall_N: null, // 白球的实例 
            angle: 0,
            showMobileResult: false,
            touchStartItem: null, // 长按计时器
            touchStartTimer: null, // 长按计时器
        };
        const oOthers = {
            oMusic: (  // 控制音乐
                import.meta.client &&
                new MusicControler(oMusicLib as any)
            ),
            aLeftBtn: deepCopy(aLeftBtn),
            isAutoMode: false,
            oForm,
            iCoinInUse: aCoinList.findIndex(cur => cur.inUse), // 正在使用中的筹码
            aRedNumber: deepCopy(aRedNumber), // 红色数字
        };
        const oGameResult = { // 保存游戏结果
            multi: 0,
            winAmount: 0,
            roll_number: -1, // 游戏结果（0-36）共 37 个
            bVisible: false,
        };
        const oGameResultEmpty = Object.freeze(
            deepCopy(oGameResult),
        );
        const oStores = {
            oSettings: useSettingsStore(),
            globalStore: useGlobalStore(),
            oUserStore: useUserStore(),
            oJoinStateStore: useJoinStateStore(),
            oGameHistoryStore: useGameHistoryStore(),
            oRates: useRatesStore().usdtComaparisonCurrencyList, // 汇率信息
            autoOption: useAutoOptionStore(),
        };
        return {
            oAutoDialog: null,
            oGameResult,
            oGameResultEmpty,
            ...oStores,
            ...oBorrowed,
            ...oForInterface,
            ...oOthers,
            specialMark: true, // ← 固定值 true，用于消除一个莫名的生产环境报错  
            showWarning: false  // 是否显示预警动画
        };
    },
    computed: {
        // ↓游戏结果弹窗中使用
        showResult(){
            return this.type === 'result';
        },
        // mini 版专用
        isDisabled: {
            get(){
                const bResult = (
                    this.isRolling || this.oForm.isSubmiting
                );
                return bResult;
            },
            set(newVal){
                0 && console.log("newVal", newVal);
            },
        },
        // ↓游戏【结果弹窗中】使用
        sRotate(){
            if (!this.showResult) return '';
            if (import.meta.server || (this.globalStore.innerWidth <= 550)){
                return ''; // 此处为空，将使用其它方案 
            }
            return `scale(0.9) rotate(90deg) translate(1%, ${sTranslateY})`;
        },
        // ↓ 下注限定
        // ↓ 返回值中的 min 同时表示 单个筹码代表的金额
        oBetLimit(){
            if (!this.oJoinStateStore.hasGameHistoryLoaded) {
                return {min: 0, max: 0};
            }
            const oConfig = this.oJoinStateStore.config[
                this.oUserStore.oNowCurrency.currencyName
            ] || {};
            const oResult:BetLimit = {
                min: oConfig?.minBetAmount || 0,
                max: oConfig?.maxBets || 0,
            }
            return oResult;
        },
        // ↓ 筹码列表（附带筹码金额信息和提示信息 
        aCoinArr(){
            // ↓重要举措，防止余额不足时筹码禁用状态偶尔失真 
            if (!this.globalStore.client) {
                return this.aCoinList;
            }
            const balance = this.oUserStore.oNowCurrency?.balance;
            const betAmount = this.oForm.amount;
            const {t: $tFn} = useNuxtApp().$i18n;
            const aResult = this.aCoinList.map(cur => {
                // ↓ 单个筹码的价值
                cur.amount = (cur.value * this.oBetLimit.min);
                cur.amountStr = cur.amount.toLocaleString(void 0, {
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1,
                });
                cur.sTip = '';
                const fAmountWillBe = betAmount + cur.amount;
                if (
                    (balance < cur.amount)
                    || (balance < fAmountWillBe)
                ){
                    cur.sTip = $tFn('roulette.InsufficientBalance');
                }else if (fAmountWillBe > this.oBetLimit.max){
                    cur.sTip = $tFn('roulette.MaxBetReached');
                }
                return cur;
            });
            return aResult;
        },
        // ↓ 当前被激活的筹码
        oCoinInUse(){
            let oTarget = this.aCoinArr[this.iCoinInUse];
            oTarget ||= this.aCoinArr.at(-1);
            return oTarget;
        },
        // === ↑以上是关于筹码的相关计算 ==============================================
        // ↓ 没钱不能投注
        choosable(){
            const arr = [
                this.oUserStore.oNowCurrency.balance > 0,
                !this.oCoinInUse.sTip,
            ];
            // console.log("choosable: ", arr);
            const bResult = arr.every(Boolean);
            return bResult;
        },
        //  ↓ 是否禁用下注按钮
        betButtonDisabled(){
            if (this.oForm.isSubmiting){
                // 自动下注期间不禁用，以便用户可以终止自动模式 
                return false; 
            }
            const arr = [
                this.isRolling,
                this.oForm.amount > 0 === false, 
                this.oUserStore.oNowCurrency.balance > 0 == false,
            ];
            return arr.some(Boolean);
        },
        isFast(){
            return this.oSettings.inhouseGames.roulette.fast;
        },
        animation(){
            return this.oSettings.inhouseGames.roulette.animation;
        },
        // ↓表示是否在移动端
        mobileMode(){
            // 优先认定为移动端
            if (!this.globalStore.client || !this.globalStore.innerWidth){
                return true;
            }
            return this.globalStore.innerWidth <= 550;
        },
        // ↓表示是否左侧面板置于下方（疑似 mini 版中无效）
        leftPanalDown(){
            if (!this.globalStore.client) return false;
            if (!this.globalStore.innerWidth){
                return true; // 宽度信息不明，优先认定为移动端
            }
            return this.globalStore.innerWidth <= this.iWithB;
        },
        // ↓ 游戏结果
        aGameResult(){
            let {response = []} = this.oGameHistoryStore.gameHistoryDelay;
            return Object.freeze(response.map(thisOne => {
                const cur = deepCopy(thisOne);
                const iNo = 1 * (cur.randomSeed || '').split('_')[0];
                cur.rollNumber_ = iNo;
                cur.color_ = (()=>{
                    if (iNo === 0) return 'green';
                    if (this.aRedNumber.includes(iNo)) return 'red';
                    return 'black';
                })();
                return cur;
            }));
        },
        // 👇 下注金额转美元（疑似在 Mini 版用被弃用）
        fAmountUSD(){
            const {currencyName} = this.oUserStore.oNowCurrency;
            const {amount = 0} = this.oForm;
            if (currencyName === 'usdt'){
                return amount;
            }
            const fRate = this.oRates[`usdt${currencyName}`];
            const fUSD = amount / fRate;
            // console.log("美元：", fUSD); 
            return fUSD;
        },
    },
    watch: {
        globalStore: {
            deep: true,
            immediate: true,
            handler(oNew){
                if (import.meta.server) return;
                // ↓ 给 innerWidth 添加默认值，以使优先推定为移动端  
                const innerWidth = oNew.innerWidth || 400; 
                const iStandard = 1030;
                const {bg01Image, bg02Image, showResult} = this;
                const noScale = [
                    innerWidth >= iStandard,
                    innerWidth <= 550,
                    innerWidth >= 700 && innerWidth <= this.iWithB,
                ].some(Boolean);
                let scaleValue = 1;
                if (noScale){
                    scaleValue = 1;
                }else if(innerWidth < 700){
                    scaleValue = innerWidth / 700;
                }else{
                    scaleValue = innerWidth / iStandard;
                }
                this.stageTransform = `translateX(0) scale(${ scaleValue })`;
                // 
                if (innerWidth <= 550){
                    this.bgImage = bg02Image;
                    let iScale = innerWidth / 550;
                    if (showResult) iScale *= 0.9;
                    this.showMobileResult = false;
                    this.betsBtnTransform = `scale(${iScale}) rotate(90deg) translate(1%, ${sTranslateY})`;
                }else{
                    this.bgImage = bg01Image;
                    this.betsBtnTransform = '';
                    this.showMobileResult = true;
                }
            },
        },
        // ↓ 监听用户的下注筹码数量变化，计算金额 
        aOptionList: {
            deep: true,
            // immediate: true,
            handler(aNewValue){
                this.oForm.amount = this.calculateFormAmount();
                // console.log('watch 赋值 amount =', this.oForm.amount);
            },
        },
        // ↓ sTip 非空，表示被禁用了
        'oForm.amount': {
            handler(){
                // console.log("sTip =", this.iCoinInUse, this.oCoinInUse.sTip);
                const aUsable = this.aCoinArr.filter(cur => {
                    return !cur.sTip; // 没有 sTip 是可选的筹码 
                });
                const iLast = Math.max(0, aUsable.length - 1);
                if (this.iCoinInUse > iLast){
                    this.setChipInUse(iLast);
                }
            },
        },
        // ↓ 加载上局的布局 
        'oJoinStateStore.hasGameHistoryLoaded': {
            immediate: true,
            handler(bNewVal){
                if (import.meta.server) return; 
                if (bNewVal && !this.oForm.amount){
                    this.useChipsRecord(); 
                }
            },
        },
        // ↓ 用于显示游戏历史  
        historyData: {
            deep: true,
            immediate: true,
            handler(oNewHistory){
                if (import.meta.server) return;
                const id = oNewHistory?._id;
                if (!id) return;
                const oData = deepCopy(oNewHistory);
                this.useHistoryData(oData);
                // console.log('某局游戏历史初步设定完毕：', deepCopy(oData));
                // console.log('赋值结果：', deepCopy(this.aOptionList));
            },
        },
    },
    // ↓生命周期 ------------------------
    ...{
        mounted(){
            const { stopInfinity, startInfinity, } = useAutoBetToolKit(
                this.oForm,
                this.submitTheBet,
                {
                    fnIncrease: this.fnIncrease,
                    fnReset: this.fnReset,
                },
            );
            Object.assign(this, {
                stopInfinity, 
                startInfinity,
            });
            // 开始绘制小球
            this.toDrawTheBall();
            this.currentLanguage = useNuxtApp().$i18n.locale;
        },
        beforeUnmount(){
            this.oMusic?.toDestory();
            if (this.oBall_N?.live){
                this.oBall_N.live = false; // 关闭循环
            }
        },
    },
    methods: {
        ...oMethods,
        // 是否触发预警动画
        async handleClickMask() {
            if (this.showWarning) return;
            if (this.oForm.amount <= 0) {
                this.showWarning = true;
                await Sleep(800);
                this.showWarning = false;
            }
        },
    },
});


</script>


<style lang="scss">
/* 非 scoped 项 */
.board__stats-cells[name="a309dkgtg8u69okvn"]::-webkit-scrollbar {
    width: 3px;
    height: 3px;
}

</style>


<style scoped lang="scss" src="./style/roulette.scss" ></style>
<style scoped lang="scss" src="./style/roulette-left.scss" ></style>
<style scoped lang="scss" src="./style/roulette-self.scss" ></style>
<style scoped lang="scss" src="./style/RouletteChip.scss" ></style>



